/* global $: false, noUiSlider: false */
$(function () {
    initSliders();
});

function initSliders() {
    const sliders = document.querySelectorAll('.js-slides');

    for (let i = 0; i < sliders.length; i++) {
        const slider = sliders[i];
        const minVal = parseInt(slider.dataset.min);
        const maxVal = parseInt(slider.dataset.max);
        const stepVal = parseInt(slider.dataset.step);
        const startMinVal = parseInt(slider.dataset.startMin);
        const startMaxVal = parseInt(slider.dataset.startMax);

        // inputs
        const startMinInput = slider.closest('.js-handle-slides').querySelector('.js-min-val');
        const startMaxInput = slider.closest('.js-handle-slides').querySelector('.js-max-val');

        // Initialize handle slider
        noUiSlider.create(slider, {
            connect: true,
            start: [startMinVal, startMaxVal],
            step: stepVal,
            range: {
                min: [minVal],
                max: [maxVal],
            },
        });

        // Change event of inputs
        $(startMinInput).on('change', (event, source) => {
            if (source === 'sliderSet') {
                return;
            }

            slider.noUiSlider.set([startMinInput.value, startMaxInput.value], false);
        });

        $(startMaxInput).on('change', (event, source) => {
            if (source === 'sliderSet') {
                return;
            }

            slider.noUiSlider.set([startMinInput.value, startMaxInput.value], false);
        });

        // Update event of handles
        slider.noUiSlider.on('update', (values) => {
            startMinInput.value = Math.round(values[0]);
            startMaxInput.value = Math.round(values[1]);
        });

        slider.noUiSlider.on('set', () => {
            $(startMinInput).trigger('change', 'sliderSet');
            $(startMaxInput).trigger('change', 'sliderSet');
        });
    }
}
